import { render, staticRenderFns } from "./BKSort.vue?vue&type=template&id=4c39f7f0&scoped=true"
import script from "./BKSort.vue?vue&type=script&lang=js"
export * from "./BKSort.vue?vue&type=script&lang=js"
import style0 from "./BKSort.vue?vue&type=style&index=0&id=4c39f7f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c39f7f0",
  null
  
)

export default component.exports